import { AND } from '@/lib/filter/scope-tree';
import { guid } from 'shared/lib/uuid';
import { userScopeType } from 'shared/constants.json';

const baseFilter = ({ account, op = AND }) => ({
  account,
  op,
  children: [],
});

export const filter = ({ property, spaces, account }) => {
  if (property === null) {
    return baseFilter({ account });
  }
  return {
    account,
    op: AND,
    children: [
      {
        key: guid(),
        op: AND,
        isGroup: true,
        children: [
          {
            op: AND,
            children: [
              {
                scope: {
                  isEmpty: false,
                  property,
                  type: userScopeType.property,
                  spaces: spaces.map((o) => ({ uid: o.uid })),
                },
              },
            ],
          },
        ],
      },
    ],
  };
};
